import React from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import { getImages } from '../../Common/const';
import ReadMore from '../../Common/ReadMore';

const InventorySmBox = ({ item, index, numberFormatter, priceFormatter }) => {

    const optionssl = {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true
    };

    const locationClass = item.location === "San Clemente, CA" ? "orange-tag" : "gray-tag";
    return (
        <>
            <div className='col-lg-4 col-md-6 col-12' key={index}>
                <div className='pro-box'>
                    <div className='pro-content'>
                        <div className='before-hover'>
                            <div className='pro-top position-relative'>
                                <Link
                                    to={"/vehicle-details/" + item.vdp_url}>
                                        {item.images?.length > 0 ? 
                                            <img 
                                                src={item.images[0]} alt='srp' 
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = getImages(`srp_coming_soon_right.jpeg`);
                                                }}
                                            /> :
                                            <img 
                                                src={getImages('srp_coming_soon_right.jpeg')} alt='srp' 
                                            />
                                        }
                                </Link>
                                <div className={`card-location-tag ${locationClass}`}>{item.location}</div>
                                    <div className={`pro-pending-tag ${!item?.inventory_manage?.pending && "d-none"}`}>
                                        <img src={getImages('sale-pending-srp.png')} alt='sale pending'/>
                                    </div>
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className="fv-title mb-0">{item.vehicle_name}</div>
                                    <div>
                                        <button className='info-icon'>
                                            <img src={getImages('info-icon.png')} alt='icon' />
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                    <div className="fv-price">{priceFormatter(item.price, true)}</div>
                                    <div className="fv-mileage">{priceFormatter(item.mileage)} miles</div>
                                </div>
                                <div className='mt-2'>
                                    <Link
                                        to={"/vehicle-details/" + item.vdp_url}
                                        type='button'
                                        className='vehicle-dtl-btn xs-title text-uppercase text-center'>
                                        Vehicle Details
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className='after-hover'>
                            <div className='pro-top'>
                                {item.images?.length > 0 ? 
                                    <Slider
                                        className="featured-slider"
                                        {...optionssl}
                                    >
                                        <div className="slide-item">
                                            <Link to={"/vehicle-details/" + item.vdp_url}>
                                                <img src={item.images[0]} />
                                            </Link>
                                        </div>
                                        <div className="slide-item">
                                            <Link to={"/vehicle-details/" + item.vdp_url}>
                                                <img src={item.images[1]} />
                                            </Link>
                                        </div>
                                        <div className="slide-item">
                                            <Link to={"/vehicle-details/" + item.vdp_url}>
                                                <img src={item.images[2]} />
                                            </Link>
                                        </div>
                                    </Slider> :
                                    <img 
                                        src={getImages('srp_coming_soon_right.jpeg')} alt='srp' 
                                    />
                                }
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between prob-info flex-wrap">
                                    <div className='w-50 pe-3'>
                                        <div className='d-flex align-items-center w-100 mb-xl-2'>
                                            <div className='xs-title fw-400 w-30'>Stock #</div>
                                            <div className='sm-title w-70'>{item.stockno}</div>
                                        </div>
                                        <div className='d-flex align-items-center w-100'>
                                            <div className='xs-title fw-400 w-30'>VIN</div>
                                            <div className='sm-title w-70'>{item.vin}</div>
                                        </div>
                                    </div>
                                    <div className='w-50 ps-3'>
                                        {item.interior_color &&
                                            <div className='d-flex align-items-center w-100 mb-xl-2'>
                                                <div className='xs-title fw-400 w-40'>Interior Color</div>
                                                <div className='sm-title text-end w-60'>{item.interior_color}</div>
                                            </div>
                                        }
                                        {item.exterior_color &&
                                            <div className='d-flex align-items-center w-100'>
                                                <div className='xs-title fw-400 w-40'>Exterior Color</div>
                                                <div className='sm-title text-end w-60'>{item.exterior_color}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <hr className='custom-hr' />
                                <ReadMore
                                    key={index}
                                    text={item.description}
                                    maxChars={230}
                                    sectionId="aboutVdp"
                                    readMoreUrl={"/vehicle-details/" + item.vdp_url}
                                />
                                <div className="d-flex align-items-center justify-content-between mt-2 pt-2 srp-actions-flex">
                                    <div className='w-60'>
                                        <Link to={"https://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DVW_1&vin=" + item.vin} className="xs-title avenir-next font-1-1em text-orange text-start fw-500" target="_blank" rel="noreferrer">
                                            <div>Open Report</div>
                                            <div className='srp-carfax'><img src={getImages('carfax-tag.png')}/></div>
                                        </Link>
                                    </div>
                                    <div className='w-40 text-center'>
                                        <Link to={"/vehicle-details/" + item.vdp_url} className="vehicle-dtl-btn xs-title text-uppercase text-center" >Vehicle Details</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InventorySmBox